import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { logger } from './utils/logger';
import { ErrorHandler } from './utils/errorHandler';
import './App.css';

// グローバルエラーハンドリング
window.addEventListener('error', (event) => {
  logger.error('GLOBAL', 'グローバルエラー', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  const error = ErrorHandler.handleGenericError(event.reason, '未処理Promise');
  logger.error('GLOBAL', '未処理Promise拒否', error);
  event.preventDefault(); // コンソールエラーを防ぐ
});

// モバイルでのビューポート高さ変化対応
function setViewportHeight() {
  // 実際のビューポート高さを CSS Custom Property として設定
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// 初期設定
setViewportHeight();

// リサイズ時とオリエンテーション変更時に再設定
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', () => {
  // オリエンテーション変更は少し遅延させる
  setTimeout(setViewportHeight, 100);
});

// スマホでのアドレスバー表示/非表示による背景画像再描画を防ぐ
let ticking = false;
function handleScroll() {
  if (!ticking) {
    requestAnimationFrame(() => {
      setViewportHeight();
      ticking = false;
    });
    ticking = true;
  }
}

// スクロール時の背景固定強化（パッシブリスナーでパフォーマンス向上）
window.addEventListener('scroll', handleScroll, { passive: true });

// React 18の新しいcreateRoot APIを使用
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
